module.exports = __webpack_public_path__ + "static/img/brees-2006-top.45c8185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2006-top.jpg
// module id = Cdjl
// module chunks = 1